<div class="main">
    <div class="main__container">
        <swb-header></swb-header>
        <div class="content">
            <div style="position: relative; width: 100%" [style.minHeight.px]="browseConfig ? browseConfig.height : 0">
                <div [@routerTransition]="getState(o)">
                    <div class="content__wrapper">
                        <router-outlet #o="outlet">
                        </router-outlet>
                    </div>
                </div>
            </div>
            <router-outlet name="modal-form"></router-outlet>
            <router-outlet name="browse"></router-outlet>
            <swb-file-browse *ngIf="browseConfig && browseConfig.open" [browseConfig]="browseConfig"></swb-file-browse>
        </div>
        <swb-navigation></swb-navigation>
    </div>
</div>
<router-outlet name="modal"></router-outlet>
